'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var zod = require('zod');
var nthHookSettings = require('@narvar/nth-hook-settings');
var updateItemRemainingEligibleQuantity = require('./utils/updateItemRemainingEligibleQuantity.js');
var updateEvaluatedItemEligibility = require('./utils/updateEvaluatedItemEligibility.js');
var getFullItemDetails = require('./utils/getFullItemDetails.js');
var updateEvaluatedPackageEligibility = require('./utils/updateEvaluatedPackageEligibility.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

let ItemClaimType = /*#__PURE__*/function (ItemClaimType) {
  ItemClaimType["ItemDamaged"] = "ItemDamaged";
  ItemClaimType["ItemMissing"] = "ItemMissing";
  ItemClaimType["WrongItem"] = "WrongItem";
  return ItemClaimType;
}({});
const ItemClaimTypeEnum = zod.z.nativeEnum(ItemClaimType);
function isItemClaimType(value) {
  return ItemClaimTypeEnum.safeParse(value).success;
}
let ClaimType = /*#__PURE__*/function (ClaimType) {
  ClaimType["PackageMissing"] = "PackageMissing";
  ClaimType["ItemDamaged"] = "ItemDamaged";
  ClaimType["ItemMissing"] = "ItemMissing";
  ClaimType["WrongItem"] = "WrongItem";
  return ClaimType;
}({});
const CreateClaimPhotosSchema = zod.z.object({
  contentType: zod.z.enum(['image/jpeg', 'image/jpg', 'image/png']),
  size: zod.z.number().lte(10_485_760) // 10MB
}).array();

// TODO: Replace this with a type associated with a yet-to-be-developed
// createClaim API
// TODO: Replace this with a type associated with a yet-to-be-developed
// createClaim API
// TODO: Replace this with a type associated with a yet-to-be-developed
// createClaim API
let ClaimStepId = /*#__PURE__*/function (ClaimStepId) {
  ClaimStepId["QUANTITY"] = "QUANTITY";
  ClaimStepId["PHOTOS"] = "PHOTOS";
  ClaimStepId["ADDITIONAL_INFO"] = "ADDITIONAL_INFO";
  return ClaimStepId;
}({});
let ClaimBuilderEvent = /*#__PURE__*/function (ClaimBuilderEvent) {
  ClaimBuilderEvent["ORDER_LOOKUP_SUCCESS"] = "ORDER_LOOKUP_SUCCESS";
  ClaimBuilderEvent["OTP_STEP_COMPLETED"] = "OTP_STEP_COMPLETED";
  ClaimBuilderEvent["CLAIM_ITEM_SELECTED"] = "CLAIM_ITEM_SELECTED";
  ClaimBuilderEvent["CLAIM_ITEM_DETAIL_STEP_DISMISSED"] = "CLAIM_ITEM_DETAIL_STEP_DISMISSED";
  ClaimBuilderEvent["CLAIM_ITEM_DETAIL_UPDATED"] = "CLAIM_ITEM_DETAIL_UPDATED";
  ClaimBuilderEvent["CLAIM_PACKAGE_DETAIL_STEP_DISMISSED"] = "CLAIM_PACAKGE_DETAIL_STEP_DISMISSED";
  ClaimBuilderEvent["CLAIM_PACKAGE_DETAIL_UPDATED"] = "CLAIM_PACKAGE_DETAIL_UPDATED";
  ClaimBuilderEvent["CLAIM_SUBMIT_COMPLETED"] = "CLAIM_SUBMIT_COMPLETED";
  ClaimBuilderEvent["ITEM_CLAIM_SELECTION_COMPLETED"] = "ITEM_CLAIM_SELECTION_COMPLETED";
  ClaimBuilderEvent["PACKAGE_CLAIM_SELECTION_COMPLETED"] = "PACKAGE_CLAIM_SELECTION_COMPLETED";
  ClaimBuilderEvent["NAVIGATED_BACK"] = "NAVIGATED_BACK";
  ClaimBuilderEvent["REMOVING_CLAIMED_ITEM"] = "REMOVING_CLAIMED_ITEM";
  ClaimBuilderEvent["CLAIMED_ITEM_REMOVE_CANCELED"] = "CLAIMED_ITEM_REMOVE_CANCELED";
  ClaimBuilderEvent["REMOVING_CLAIMED_PACKAGE"] = "REMOVING_CLAIMED_PACKAGE";
  ClaimBuilderEvent["CLAIMED_PACKAGE_REMOVE_CANCELED"] = "CLAIMED_PACKAGE_REMOVE_CANCELED";
  ClaimBuilderEvent["CLAIMED_ITEM_REMOVED"] = "CLAIMED_ITEM_REMOVED";
  ClaimBuilderEvent["CLAIMED_PACKAGE_REMOVED"] = "CLAIMED_PACKAGE_REMOVED";
  ClaimBuilderEvent["INVALID_DATA_PROVIDED"] = "INVALID_DATA_PROVIDED";
  ClaimBuilderEvent["CLAIM_BUILDER_STARTED"] = "CLAIM_BUILDER_STARTED";
  return ClaimBuilderEvent;
}({});
var ClaimBuilderReducerActionType = /*#__PURE__*/function (ClaimBuilderReducerActionType) {
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["COMPLETE_CLAIM_SUBMIT"] = 0] = "COMPLETE_CLAIM_SUBMIT";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["COMPLETE_ITEM_CLAIM_SELECTION"] = 1] = "COMPLETE_ITEM_CLAIM_SELECTION";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["COMPLETE_PACKAGE_CLAIM_SELECTION"] = 2] = "COMPLETE_PACKAGE_CLAIM_SELECTION";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["DISMISS_CLAIM_ITEM_DETAIL_STEP"] = 3] = "DISMISS_CLAIM_ITEM_DETAIL_STEP";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["DISMISS_CLAIM_PACKAGE_DETAIL_STEP"] = 4] = "DISMISS_CLAIM_PACKAGE_DETAIL_STEP";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["NAVIGATE_BACK"] = 5] = "NAVIGATE_BACK";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["SET_CLAIM_ELIGIBILITY_INFO"] = 6] = "SET_CLAIM_ELIGIBILITY_INFO";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["SET_CURRENT_ITEM"] = 7] = "SET_CURRENT_ITEM";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["SET_CURRENT_ITEM_CLAIM_DETAIL"] = 8] = "SET_CURRENT_ITEM_CLAIM_DETAIL";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["SET_CURRENT_PACKAGE"] = 9] = "SET_CURRENT_PACKAGE";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["UPDATE_CURRENT_ITEM"] = 10] = "UPDATE_CURRENT_ITEM";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["UPDATE_CURRENT_PACKAGE"] = 11] = "UPDATE_CURRENT_PACKAGE";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["CONFIRM_ITEM_REMOVE"] = 12] = "CONFIRM_ITEM_REMOVE";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["CANCEL_ITEM_REMOVE"] = 13] = "CANCEL_ITEM_REMOVE";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["CONFIRM_PACKAGE_REMOVE"] = 14] = "CONFIRM_PACKAGE_REMOVE";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["CANCEL_PACKAGE_REMOVE"] = 15] = "CANCEL_PACKAGE_REMOVE";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["REMOVE_CLAIMED_ITEM"] = 16] = "REMOVE_CLAIMED_ITEM";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["REMOVE_CLAIMED_PACKAGE"] = 17] = "REMOVE_CLAIMED_PACKAGE";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["COMPLETE_OTP_STEP"] = 18] = "COMPLETE_OTP_STEP";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["HANDLE_INVALID_DATA"] = 19] = "HANDLE_INVALID_DATA";
  ClaimBuilderReducerActionType[ClaimBuilderReducerActionType["START_CLAIM_BUILDER"] = 20] = "START_CLAIM_BUILDER";
  return ClaimBuilderReducerActionType;
}(ClaimBuilderReducerActionType || {});
const ClaimBuilderContext = /*#__PURE__*/React__default["default"].createContext(null);
const ClaimBuilderProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    allowMultiPackageClaims: allowMultiPackageClaimsRaw
  } = nthHookSettings.useSettings();
  const allowMultiPackageClaims = allowMultiPackageClaimsRaw ?? true;
  const initialState = () => ({
    claimEligibilityInfo: null,
    claimType: null,
    currency: null,
    currentItemClaim: null,
    currentPackageClaim: null,
    currentPackageDetails: null,
    itemClaims: {},
    packageClaims: {},
    claimAmount: null,
    otpVerification: null,
    event: null,
    eventMetadata: {},
    cartId: crypto.randomUUID()
  });
  const reducer = (state, action) => {
    switch (action.type) {
      case ClaimBuilderReducerActionType.START_CLAIM_BUILDER:
        {
          return {
            ...initialState(),
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.COMPLETE_CLAIM_SUBMIT:
        {
          return {
            ...state,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.DISMISS_CLAIM_ITEM_DETAIL_STEP:
        {
          return {
            ...state,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.DISMISS_CLAIM_PACKAGE_DETAIL_STEP:
        {
          return {
            ...state,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.NAVIGATE_BACK:
        {
          return {
            ...state,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.COMPLETE_ITEM_CLAIM_SELECTION:
        {
          const {
            itemClaims,
            claimEligibilityInfo
          } = state;
          const claimAmount = Object.keys(itemClaims).reduce((total, itemClaimsKey) => {
            const {
              unitPrice,
              unitTax
            } = (claimEligibilityInfo === null || claimEligibilityInfo === void 0 ? void 0 : claimEligibilityInfo.items[itemClaims[itemClaimsKey].uid]) ?? {};
            if (unitPrice === null || unitPrice === undefined) throw new Error('Could not calculate item claimAmount. Unit price is null');
            const itemClaimValue = itemClaims[itemClaimsKey].quantity * (unitPrice + (unitTax ?? 0));
            return parseFloat((total + itemClaimValue).toFixed(2));
          }, 0);
          return {
            ...state,
            claimAmount,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.COMPLETE_PACKAGE_CLAIM_SELECTION:
        {
          const {
            packageClaims,
            claimEligibilityInfo
          } = state;
          const isNumber = zod.z.number({
            required_error: 'Could not calculate package claimAmount because of invalid quantity or price values',
            invalid_type_error: 'Could not calculate package claimAmount because of invalid quantity or price values'
          });
          const packagesClaimAmount = Object.keys(packageClaims).reduce((total, packageId) => {
            const {
              items
            } = (claimEligibilityInfo === null || claimEligibilityInfo === void 0 ? void 0 : claimEligibilityInfo.shipments.find(shipment => shipment.id === packageId)) ?? {};
            if (!(items !== null && items !== void 0 && items.length)) throw new Error('Could not calculate package claimAmount. No items found on shipment');
            const packageItemsClaimAmount = items.reduce((total, item) => {
              const {
                quantity
              } = item;
              const {
                unitPrice,
                unitTax
              } = (claimEligibilityInfo === null || claimEligibilityInfo === void 0 ? void 0 : claimEligibilityInfo.items[item.itemRefId]) ?? {};
              const unitPriceChecked = isNumber.parse(unitPrice);
              const eligibleQuantityChecked = isNumber.parse(quantity);
              return total + eligibleQuantityChecked * (unitPriceChecked + (unitTax ?? 0));
            }, 0);
            return parseFloat((total + packageItemsClaimAmount).toFixed(2));
          }, 0);
          return {
            ...state,
            claimAmount: packagesClaimAmount,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.SET_CLAIM_ELIGIBILITY_INFO:
        {
          if (!action.claimEligibility || !action.claimType) throw new Error(`Incomplete context for SET_CLAIM_ELIGIBILITY_INFO. Expected action.claimEligibility, action.claimType. Action: ${JSON.stringify(action)}`);
          return {
            claimEligibilityInfo: {
              ...action.claimEligibility,
              shipments: action.claimEligibility.shipments.map(shipment => {
                var _shipment$eligibility, _shipment$eligibility2, _shipment$eligibility3, _shipment$eligibility4, _shipment$eligibility5, _shipment$eligibility6, _shipment$eligibility7;
                return {
                  ...shipment,
                  evaluatedEligibility: {
                    isEligible: ((_shipment$eligibility = shipment.eligibility) === null || _shipment$eligibility === void 0 ? void 0 : _shipment$eligibility.isEligible) ?? false,
                    ineligibilityReason: ((_shipment$eligibility2 = shipment.eligibility) === null || _shipment$eligibility2 === void 0 ? void 0 : (_shipment$eligibility3 = _shipment$eligibility2.ineligibilityReasons) === null || _shipment$eligibility3 === void 0 ? void 0 : (_shipment$eligibility4 = _shipment$eligibility3[0]) === null || _shipment$eligibility4 === void 0 ? void 0 : _shipment$eligibility4.reason) ?? null,
                    ineligibilityReasonMessage: ((_shipment$eligibility5 = shipment.eligibility) === null || _shipment$eligibility5 === void 0 ? void 0 : (_shipment$eligibility6 = _shipment$eligibility5.ineligibilityReasons) === null || _shipment$eligibility6 === void 0 ? void 0 : (_shipment$eligibility7 = _shipment$eligibility6[0]) === null || _shipment$eligibility7 === void 0 ? void 0 : _shipment$eligibility7.reasonMessage) ?? null
                  },
                  items: shipment.items.map(item => {
                    var _item$eligibility, _item$eligibility2, _item$eligibility2$in, _item$eligibility3, _item$eligibility3$in;
                    return {
                      ...item,
                      evaluatedEligibility: {
                        isEligible: ((_item$eligibility = item.eligibility) === null || _item$eligibility === void 0 ? void 0 : _item$eligibility.isEligible) ?? false,
                        ineligibilityReason: ((_item$eligibility2 = item.eligibility) === null || _item$eligibility2 === void 0 ? void 0 : (_item$eligibility2$in = _item$eligibility2.ineligibilityReason) === null || _item$eligibility2$in === void 0 ? void 0 : _item$eligibility2$in.reason) ?? null,
                        ineligibilityReasonMessage: ((_item$eligibility3 = item.eligibility) === null || _item$eligibility3 === void 0 ? void 0 : (_item$eligibility3$in = _item$eligibility3.ineligibilityReason) === null || _item$eligibility3$in === void 0 ? void 0 : _item$eligibility3$in.reasonMessage) ?? null
                      }
                    };
                  })
                };
              }),
              items: action.claimEligibility.items.reduce((itemsRecord, item) => ({
                ...itemsRecord,
                [item.uid]: {
                  ...item,
                  remainingEligibleQuantity: item.maxClaimableQuantity
                }
              }), {})
            },
            currency: action.claimEligibility.items[0].currency ?? null,
            claimAmount: null,
            claimType: action.claimType,
            currentItemClaim: null,
            currentPackageClaim: null,
            currentPackageDetails: null,
            itemClaims: {},
            packageClaims: {},
            otpVerification: null,
            event: action.event,
            cartId: state.cartId
          };
        }
      case ClaimBuilderReducerActionType.SET_CURRENT_ITEM:
        {
          var _state$claimEligibili, _state$claimEligibili2, _state$claimEligibili3;
          if (!action.itemUid || !action.packageId || !state.claimType) throw new Error(`Incomplete context for SET_CURRENT_ITEM. Expected action.itemUid, state.claimType. Action: ${JSON.stringify(action)}. State: ${JSON.stringify(state)}`);
          const shipment = (_state$claimEligibili = state.claimEligibilityInfo) === null || _state$claimEligibili === void 0 ? void 0 : _state$claimEligibili.shipments.find(shipment => shipment.id === action.packageId);
          const shipmentItem = shipment === null || shipment === void 0 ? void 0 : shipment.items.find(item => item.itemRefId === action.itemUid);
          const orderItem = (_state$claimEligibili2 = state.claimEligibilityInfo) === null || _state$claimEligibili2 === void 0 ? void 0 : _state$claimEligibili2.items[action.itemUid];
          if (!orderItem || !shipmentItem) {
            throw new Error(`Could not find item details for itemUid: ${action.itemUid}`);
          }
          if (!shipmentItem.eligibility) throw new Error('No eligibility information found matching claimType');
          let currentItemClaim = state.itemClaims[`${action.itemUid}_${action.packageId}`];
          if (currentItemClaim) {
            const currentClaimStep = (action.itemClaimStepId && currentItemClaim.claimSteps.find(step => step.id === action.itemClaimStepId)) ?? currentItemClaim.claimSteps[0];
            return {
              ...state,
              currentItemClaim: {
                ...currentItemClaim,
                currentClaimStep
              },
              event: action.event,
              complete: false
            };
          }
          const itemClaimSteps = [];
          const claimTypeWorkflowConfig = (_state$claimEligibili3 = state.claimEligibilityInfo) === null || _state$claimEligibili3 === void 0 ? void 0 : _state$claimEligibili3.claimTypeConfig;
          if (!claimTypeWorkflowConfig) throw new Error('No workflow defined');
          const {
            photos,
            safeToShipConfirmation,
            comment,
            deliveryConfirmation
          } = claimTypeWorkflowConfig;

          // Determine quantity rule
          if (orderItem.remainingEligibleQuantity > 1) {
            itemClaimSteps.push({
              id: ClaimStepId.QUANTITY
            });
          }

          // Determine photos view
          if (photos !== null && photos !== void 0 && photos.show) {
            itemClaimSteps.push({
              id: ClaimStepId.PHOTOS,
              fields: {
                photos
              }
            });
          }

          // Determine additional info view
          if (state.claimType === ClaimType.ItemDamaged && (comment !== null && comment !== void 0 && comment.show || safeToShipConfirmation !== null && safeToShipConfirmation !== void 0 && safeToShipConfirmation.show)) {
            itemClaimSteps.push({
              id: ClaimStepId.ADDITIONAL_INFO,
              fields: {
                confirmation: safeToShipConfirmation ?? {
                  show: false
                },
                comment: comment ?? {
                  show: false
                }
              }
            });
          } else if (state.claimType === ClaimType.ItemMissing && (comment !== null && comment !== void 0 && comment.show || deliveryConfirmation !== null && deliveryConfirmation !== void 0 && deliveryConfirmation.show)) {
            itemClaimSteps.push({
              id: ClaimStepId.ADDITIONAL_INFO,
              fields: {
                confirmation: deliveryConfirmation ?? {
                  show: false
                },
                comment: comment ?? {
                  show: false
                }
              }
            });
          } else if (state.claimType === ClaimType.WrongItem && (comment !== null && comment !== void 0 && comment.show || deliveryConfirmation !== null && deliveryConfirmation !== void 0 && deliveryConfirmation.show)) {
            itemClaimSteps.push({
              id: ClaimStepId.ADDITIONAL_INFO,
              fields: {
                confirmation: deliveryConfirmation ?? {
                  show: false
                },
                comment: comment ?? {
                  show: false
                }
              }
            });
          }
          currentItemClaim = {
            uid: orderItem.uid,
            packageId: action.packageId,
            claimType: state.claimType,
            additionalInfo: {
              comment: '',
              confirmationChecked: false
            },
            photos: [],
            quantity: orderItem.remainingEligibleQuantity === 1 ? 1 : 0,
            claimSteps: itemClaimSteps,
            currentClaimStep: itemClaimSteps[0],
            complete: false,
            trackingNumber: (shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber) ?? null
          };
          return {
            ...state,
            currentItemClaim,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.SET_CURRENT_PACKAGE:
        {
          var _state$claimEligibili6;
          if (!(action.packageId && state.claimType && state.claimEligibilityInfo)) throw new Error(`Incomplete context for SET_CURRENT_PACKAGE. Expected action.packageId, state.claimType, state.claimEligibilityInfo.`);
          const currentPackageDetails = (state.claimEligibilityInfo.shipments || []).find(shipment => (shipment === null || shipment === void 0 ? void 0 : shipment.id) === action.packageId);
          if (!currentPackageDetails || !currentPackageDetails.trackingNumber) throw new Error(`Invalid package for SET_CURRENT_PACKAGE. packageId: ${action.packageId}`);
          const packageTotalPrice = currentPackageDetails.items.reduce((total, item) => {
            var _state$claimEligibili4, _state$claimEligibili5;
            return total + item.quantity * (((_state$claimEligibili4 = state.claimEligibilityInfo) === null || _state$claimEligibili4 === void 0 ? void 0 : (_state$claimEligibili5 = _state$claimEligibili4.items[item.itemRefId]) === null || _state$claimEligibili5 === void 0 ? void 0 : _state$claimEligibili5.unitPrice) ?? 0);
          }, 0);

          // First check the packageClaims array to see if a claim has already been created for this package
          // Otherwise, create a new PackageClaim object
          let currentPackageClaim = state.packageClaims[action.packageId];
          if (currentPackageClaim) {
            const currentClaimStep = (action.packageClaimStepId && currentPackageClaim.claimSteps.find(step => step.id === action.packageClaimStepId)) ?? currentPackageClaim.claimSteps[0];
            return {
              ...state,
              currentPackageClaim: {
                ...currentPackageClaim,
                currentClaimStep
              },
              currentPackageDetails: {
                ...currentPackageDetails,
                totalPrice: packageTotalPrice
              },
              event: action.event,
              complete: false
            };
          }
          const packageClaimSteps = [];
          const claimTypeWorkflowConfig = (_state$claimEligibili6 = state.claimEligibilityInfo) === null || _state$claimEligibili6 === void 0 ? void 0 : _state$claimEligibili6.claimTypeConfig;
          if (!claimTypeWorkflowConfig) throw new Error('No workflow defined');
          const {
            comment,
            deliveryConfirmation
          } = claimTypeWorkflowConfig;

          // Determine additional info view
          if (state.claimType === ClaimType.PackageMissing && (comment !== null && comment !== void 0 && comment.show || deliveryConfirmation !== null && deliveryConfirmation !== void 0 && deliveryConfirmation.show)) {
            packageClaimSteps.push({
              id: ClaimStepId.ADDITIONAL_INFO,
              fields: {
                confirmation: deliveryConfirmation ?? {
                  show: false
                },
                comment: comment ?? {
                  show: false
                }
              }
            });
          }
          currentPackageClaim = {
            id: currentPackageDetails.id,
            trackingNumber: currentPackageDetails.trackingNumber,
            claimType: state.claimType,
            additionalInfo: {
              comment: '',
              confirmationChecked: false
            },
            claimSteps: packageClaimSteps,
            currentClaimStep: packageClaimSteps[0],
            complete: false
          };
          return {
            ...state,
            currentPackageClaim,
            currentPackageDetails: {
              ...currentPackageDetails,
              totalPrice: packageTotalPrice
            },
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.UPDATE_CURRENT_ITEM:
        {
          var _state$claimEligibili7;
          if (!action.itemClaimStepId || !action.itemClaimUpdate || !state.currentItemClaim) {
            throw new Error(`UDPATE_CURRENT_ITEM action called without any action.itemClaimUpdate, action.itemClaimStep, or state.currentClaimItem`);
          }
          const {
            currentItemClaim,
            itemClaims
          } = state;
          const orderItem = (_state$claimEligibili7 = state.claimEligibilityInfo) === null || _state$claimEligibili7 === void 0 ? void 0 : _state$claimEligibili7.items[currentItemClaim.uid];
          if (!orderItem || !state.claimEligibilityInfo || !orderItem.maxClaimableQuantity) throw new Error('Insufficient data to update item');
          const itemClaimStepIndex = action.itemClaimStepId ? currentItemClaim.claimSteps.findIndex(step => action.itemClaimStepId === step.id) : -1;
          const isLastStep = itemClaimStepIndex === currentItemClaim.claimSteps.length - 1;
          const newClaimStep = isLastStep ? currentItemClaim.currentClaimStep : currentItemClaim.claimSteps[itemClaimStepIndex + 1];
          const newCurrentItemClaim = {
            ...currentItemClaim,
            ...action.itemClaimUpdate,
            currentClaimStep: newClaimStep,
            complete: isLastStep
          };
          let newState = {
            ...state,
            currentItemClaim: newCurrentItemClaim,
            event: action.event
          };
          if (isLastStep) {
            // Customer is all done with the item details.

            // Save the updates on the itemClaims array.
            newState.itemClaims = {
              ...itemClaims,
              [`${currentItemClaim.uid}_${currentItemClaim.packageId}`]: newCurrentItemClaim
            };
            newState = updateItemRemainingEligibleQuantity["default"]({
              state: newState
            });
            newState = updateEvaluatedItemEligibility["default"]({
              state: newState,
              allowMultiPackageClaims
            });
          }
          return newState;
        }
      case ClaimBuilderReducerActionType.UPDATE_CURRENT_PACKAGE:
        {
          if (!action.packageClaimStepId || !action.packageClaimUpdate || !state.currentPackageClaim) {
            throw new Error(`UDPATE_CURRENT_PACKAGE action called without any action.packageClaimUpdate, action.packageClaimStep, or state.currentClaimPackage`);
          }
          const {
            currentPackageClaim,
            packageClaims
          } = state;
          const packageClaimStepIndex = action.packageClaimStepId ? currentPackageClaim.claimSteps.findIndex(step => action.packageClaimStepId === step.id) : -1;
          const isLastStep = packageClaimStepIndex === currentPackageClaim.claimSteps.length - 1;
          const newClaimStep = isLastStep ? currentPackageClaim.currentClaimStep : currentPackageClaim.claimSteps[packageClaimStepIndex + 1];
          const newCurrentPackageClaim = {
            ...currentPackageClaim,
            ...action.packageClaimUpdate,
            currentClaimStep: newClaimStep,
            complete: isLastStep
          };
          let newState = {
            ...state,
            currentPackageClaim: newCurrentPackageClaim,
            event: action.event
          };
          if (isLastStep) {
            // Customer is all done with the package details. Save the updates on the packageClaims array.
            newState.packageClaims = {
              ...packageClaims,
              [currentPackageClaim.id]: newCurrentPackageClaim
            };
            newState = updateEvaluatedPackageEligibility["default"]({
              state: newState,
              allowMultiPackageClaims
            });
          }
          return newState;
        }
      case ClaimBuilderReducerActionType.CONFIRM_ITEM_REMOVE:
        {
          return {
            ...state,
            event: action.event,
            eventMetadata: {
              claimLevel: 'item',
              claimedItemKey: action.claimedItemKey
            }
          };
        }
      case ClaimBuilderReducerActionType.CONFIRM_PACKAGE_REMOVE:
        {
          return {
            ...state,
            event: action.event,
            eventMetadata: {
              claimLevel: 'package',
              shipmentId: action.shipmentId
            }
          };
        }
      case ClaimBuilderReducerActionType.CANCEL_PACKAGE_REMOVE:
      case ClaimBuilderReducerActionType.CANCEL_ITEM_REMOVE:
        {
          return {
            ...state,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.REMOVE_CLAIMED_ITEM:
        {
          if (!state.currentItemClaim || !state.claimEligibilityInfo || !state.eventMetadata) {
            throw new Error('REMOVE_CLAIMED_ITEM action called without correct item ref ID or package ID, or state.currentClaim/state.claimEligibilityInfo');
          }
          const {
            currentItemClaim,
            itemClaims,
            claimEligibilityInfo,
            eventMetadata: {
              claimLevel,
              claimedItemKey
            }
          } = state;
          const orderItem = claimEligibilityInfo === null || claimEligibilityInfo === void 0 ? void 0 : claimEligibilityInfo.items[currentItemClaim.uid];
          if (!orderItem || !orderItem.maxClaimableQuantity || !claimLevel || !claimedItemKey) throw new Error('Insufficient data to update item');
          const newItemClaims = {
            ...itemClaims
          };
          delete newItemClaims[claimedItemKey];
          let newState = {
            ...state,
            itemClaims: newItemClaims,
            event: action.event
          };
          newState = updateItemRemainingEligibleQuantity["default"]({
            state: newState
          });
          newState = updateEvaluatedItemEligibility["default"]({
            state: newState,
            allowMultiPackageClaims
          });
          return newState;
        }
      case ClaimBuilderReducerActionType.REMOVE_CLAIMED_PACKAGE:
        {
          if (!state.currentPackageClaim || !state.claimEligibilityInfo || !state.eventMetadata) {
            throw new Error('REMOVE_CLAIMED_SHIPMENT action called without enough information');
          }
          const {
            packageClaims,
            eventMetadata: {
              claimLevel,
              shipmentId
            }
          } = state;
          if (!claimLevel || !shipmentId || !packageClaims) throw new Error('Insufficient data to update');
          const newPackageClaims = {
            ...packageClaims
          };
          delete newPackageClaims[shipmentId];
          const newState = {
            ...state,
            packageClaims: newPackageClaims,
            event: action.event
          };
          return updateEvaluatedPackageEligibility["default"]({
            state: newState,
            allowMultiPackageClaims
          });
        }
      case ClaimBuilderReducerActionType.COMPLETE_OTP_STEP:
        {
          const {
            otpVerification
          } = action;
          if (!otpVerification) {
            throw new Error(`COMPLETE_OTP_STEP action called without any otpVerification`);
          }
          return {
            ...state,
            otpVerification,
            event: action.event
          };
        }
      case ClaimBuilderReducerActionType.HANDLE_INVALID_DATA:
        {
          return {
            ...state,
            event: action.event
          };
        }
      default:
        throw new Error('unrecognized action sent to ClaimBuilder reducer');
    }
  };
  const [state, dispatch] = React.useReducer(reducer, initialState());
  const getFullItemDetails$1 = React.useCallback((itemUid, packageId) => {
    return getFullItemDetails["default"]({
      claimEligibilityInfo: state.claimEligibilityInfo,
      itemUid,
      packageId
    });
  }, [state.claimEligibilityInfo]);

  /**
   * This is only necessary if the ClaimBuilderProvider doesn't get re-rendered every
   * time a user enters into a new claim creation flow in the same page session. Every
   * time the ClaimBuilderProvider is recreated, it will start off with the correct initial
   * state. If ClaimBuilderProvider is long-lived, then we need to call this function
   * when we want to start a new claim creation flow.
   */
  const startClaimBuilder = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.START_CLAIM_BUILDER,
      event: ClaimBuilderEvent.CLAIM_BUILDER_STARTED
    });
  }, []);
  const handleNavigateBack = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.NAVIGATE_BACK,
      event: ClaimBuilderEvent.NAVIGATED_BACK
    });
  }, []);
  const handleDismissItemClaimDetailStep = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.DISMISS_CLAIM_ITEM_DETAIL_STEP,
      event: ClaimBuilderEvent.CLAIM_ITEM_DETAIL_STEP_DISMISSED
    });
  }, []);
  const handleDismissPackageClaimDetailStep = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.DISMISS_CLAIM_PACKAGE_DETAIL_STEP,
      event: ClaimBuilderEvent.CLAIM_PACKAGE_DETAIL_STEP_DISMISSED
    });
  }, []);
  const handleOrderLookupSuccess = React.useCallback(_ref2 => {
    let {
      claimEligibility,
      claimType
    } = _ref2;
    dispatch({
      type: ClaimBuilderReducerActionType.SET_CLAIM_ELIGIBILITY_INFO,
      event: ClaimBuilderEvent.ORDER_LOOKUP_SUCCESS,
      claimEligibility,
      claimType
    });
  }, []);
  const handleCompleteItemClaimSelection = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.COMPLETE_ITEM_CLAIM_SELECTION,
      event: ClaimBuilderEvent.ITEM_CLAIM_SELECTION_COMPLETED
    });
  }, []);
  const handleItemClaimSelection = React.useCallback(_ref3 => {
    let {
      itemUid,
      packageId,
      step
    } = _ref3;
    dispatch({
      type: ClaimBuilderReducerActionType.SET_CURRENT_ITEM,
      event: ClaimBuilderEvent.CLAIM_ITEM_SELECTED,
      itemUid,
      packageId,
      itemClaimStepId: step
    });
  }, []);
  const handleCompletePackageClaimSelection = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.COMPLETE_PACKAGE_CLAIM_SELECTION,
      event: ClaimBuilderEvent.PACKAGE_CLAIM_SELECTION_COMPLETED
    });
  }, []);
  const handlePackageClaimSelection = React.useCallback(_ref4 => {
    let {
      packageId,
      step
    } = _ref4;
    dispatch({
      type: ClaimBuilderReducerActionType.SET_CURRENT_PACKAGE,
      event: ClaimBuilderEvent.CLAIM_ITEM_SELECTED,
      packageId,
      packageClaimStepId: step
    });
  }, []);
  const handleItemClaimDetailUpdate = React.useCallback(_ref5 => {
    let {
      update,
      step
    } = _ref5;
    dispatch({
      type: ClaimBuilderReducerActionType.UPDATE_CURRENT_ITEM,
      event: ClaimBuilderEvent.CLAIM_ITEM_DETAIL_UPDATED,
      itemClaimStepId: step,
      itemClaimUpdate: update
    });
  }, []);
  const handlePackageClaimDetailUpdate = React.useCallback(_ref6 => {
    let {
      update,
      step
    } = _ref6;
    dispatch({
      type: ClaimBuilderReducerActionType.UPDATE_CURRENT_PACKAGE,
      event: ClaimBuilderEvent.CLAIM_PACKAGE_DETAIL_UPDATED,
      packageClaimStepId: step,
      packageClaimUpdate: update
    });
  }, []);
  const handleSubmitClaimSuccess = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.COMPLETE_CLAIM_SUBMIT,
      event: ClaimBuilderEvent.CLAIM_SUBMIT_COMPLETED
    });
  }, []);
  const handleConfirmRemoveClaim = React.useCallback(_ref7 => {
    let {
      claimLevel,
      id
    } = _ref7;
    if (claimLevel === 'item') {
      dispatch({
        type: ClaimBuilderReducerActionType.CONFIRM_ITEM_REMOVE,
        event: ClaimBuilderEvent.REMOVING_CLAIMED_ITEM,
        claimedItemKey: id
      });
    } else if (claimLevel === 'package') {
      dispatch({
        type: ClaimBuilderReducerActionType.CONFIRM_PACKAGE_REMOVE,
        event: ClaimBuilderEvent.REMOVING_CLAIMED_PACKAGE,
        shipmentId: id
      });
    }
  }, []);
  const handleClaimedItemRemoveCancel = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.CANCEL_ITEM_REMOVE,
      event: ClaimBuilderEvent.CLAIMED_ITEM_REMOVE_CANCELED
    });
  }, []);
  const handleRemoveClaimedItem = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.REMOVE_CLAIMED_ITEM,
      event: ClaimBuilderEvent.CLAIMED_ITEM_REMOVED
    });
  }, []);
  const handleClaimedPackageRemoveCancel = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.CANCEL_PACKAGE_REMOVE,
      event: ClaimBuilderEvent.CLAIMED_PACKAGE_REMOVE_CANCELED
    });
  }, []);
  const handleRemoveClaimedPackage = React.useCallback(() => {
    dispatch({
      type: ClaimBuilderReducerActionType.REMOVE_CLAIMED_PACKAGE,
      event: ClaimBuilderEvent.CLAIMED_PACKAGE_REMOVED
    });
  }, []);
  const handleOtpStepComplete = React.useCallback(otpVerification => {
    dispatch({
      type: ClaimBuilderReducerActionType.COMPLETE_OTP_STEP,
      event: ClaimBuilderEvent.OTP_STEP_COMPLETED,
      otpVerification
    });
  }, []);
  const handleInvalidData = () => {
    dispatch({
      type: ClaimBuilderReducerActionType.HANDLE_INVALID_DATA,
      event: ClaimBuilderEvent.INVALID_DATA_PROVIDED
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(ClaimBuilderContext.Provider, {
    value: {
      state,
      startClaimBuilder,
      getFullItemDetails: getFullItemDetails$1,
      handleItemClaimDetailUpdate,
      handleNavigateBack,
      handleDismissItemClaimDetailStep,
      handleDismissPackageClaimDetailStep,
      handleOrderLookupSuccess,
      handleCompleteItemClaimSelection,
      handleItemClaimSelection,
      handleCompletePackageClaimSelection,
      handlePackageClaimSelection,
      handlePackageClaimDetailUpdate,
      handleSubmitClaimSuccess,
      handleConfirmRemoveClaim,
      handleClaimedItemRemoveCancel,
      handleRemoveClaimedItem,
      handleRemoveClaimedPackage,
      handleClaimedPackageRemoveCancel,
      handleOtpStepComplete,
      handleInvalidData
    }
  }, children);
};
var ClaimBuilderProvider$1 = nthHookSettings.withSettingsProvider(ClaimBuilderProvider, {
  settingsRequested: `
    allowMultiPackageClaims
  `
});
const useClaimBuilder = () => {
  const context = React.useContext(ClaimBuilderContext);
  if (!context) {
    throw new Error('No context provided for ClaimBuilderContext provider');
  }
  return context;
};

exports.ClaimBuilderContext = ClaimBuilderContext;
exports.ClaimBuilderEvent = ClaimBuilderEvent;
exports.ClaimStepId = ClaimStepId;
exports.ClaimType = ClaimType;
exports.CreateClaimPhotosSchema = CreateClaimPhotosSchema;
exports.ItemClaimType = ItemClaimType;
exports["default"] = ClaimBuilderProvider$1;
exports.isItemClaimType = isItemClaimType;
exports.useClaimBuilder = useClaimBuilder;
